<a class="logo-link d-flex align-items-center text-truncate" [routerLink]="targetRoute()" data-test="header-logo-link">
  <mwe-header-logo-image />
  <span role="presentation" class="header-logo text-nowrap mb-0" [translate]="title()"></span>
</a>
